import React, {useState} from 'react';
import { FormControl, InputLabel, OutlinedInput, InputAdornment, IconButton, FormHelperText, Box } from '@mui/material';
import ColorUtils from '../utils/colors'

export function FormInput(props) {
  const [hide, setHide] = useState(props.type === 'password' ? true : false)
  const [focused, setFocused] = useState(false)

  return (
    <FormControl 
      fullWidth={!props.wrapContent} 
      variant="outlined" 
      error={!!props.error} 
      size={props.size} 
      style={props.style}
    >
      <InputLabel 
        htmlFor="component-simple"
        sx={{
          color: focused ? '#1E88E5' : '#64748B',
          '&.Mui-focused': { color: '#1E88E5' },
          '&.Mui-error': { color: '#EF4444' },
          fontSize: '0.95rem',
          fontWeight: 500,
        }}
      >
        {props.label}
      </InputLabel>
      <OutlinedInput 
        type={props.type === 'password' ? (hide ? 'password' : 'text') : props.type} 
        startAdornment={
          props.start_icon && <InputAdornment position="start">
            <i className={`iconfont ${props.start_icon}`} style={{
              marginRight: '4px',
              fontSize: '1.4rem',
              color: props.error ? '#EF4444' : (focused ? '#1E88E5' : '#94A3B8'),
              transition: 'color 0.2s ease',
            }}></i>
          </InputAdornment>
        } 
        endAdornment={
          props.type === 'password' && <InputAdornment position="end">
            <IconButton 
              onClick={() => setHide(!hide)}
              edge="end"
              sx={{ color: '#94A3B8' }}
            >
              <i className={`iconfont ${hide ? 'icon-eyeslash' : 'icon-eye'}`} style={{
                fontSize: '1.2rem',
              }}></i>
            </IconButton>
          </InputAdornment>
        } 
        label={props.label} 
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        sx={{
          backgroundColor: '#F8FAFC',
          color: '#1E293B',
          borderRadius: '12px',
          transition: 'all 0.2s ease-in-out',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0,0,0,0.08)',
            borderWidth: '1px',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(30, 136, 229, 0.3)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#1E88E5',
            borderWidth: '2px',
            boxShadow: '0 0 0 4px rgba(30, 136, 229, 0.1)',
          },
          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EF4444',
          },
          '& input': {
            py: 1.8,
            fontSize: '0.95rem',
            fontWeight: 500,
          }
        }} 
        defaultValue={props.defaultValue} 
        value={props.value} 
        placeholder={props.placeholder} 
        onChange={(event) => {
          if (!event) return
          props.onChange(event)
        }} 
        multiline={props.multiline} 
        minRows={props.minRows ? props.minRows : (props.multiline ? 3 : 1)} 
        onKeyDown={props.onKeyDown}
      />
      {
        props.error && <FormHelperText sx={{ mx: 1, mt: 0.5, fontWeight: 500, color: '#EF4444' }}>{props.error}</FormHelperText>
      }
    </FormControl>
  )
}

export default FormInput;